import { gql } from "@apollo/client"

export const getValorationBySubmission = gql`
query getValorationBySubmission($submission: ID!){
  Valoration:ValorationBySubmission(submission: $submission){
    id
    createdAt
    modifiedAt
    val
    comment
    owner {
      id
      displayName
      roles {
        role
        regions
      }
      email
      uid
    }
  }
}
`